export const ERRORS = {
    PRODUCTS_NOT_FOUND: 'PRODUCTS_NOT_FOUND',
};
